module.exports = __webpack_public_path__ + "img/messaging.eeae7317.svg";